const practices = [
  { icon: 'ri-file-list-3-line', title: 'Реальные кейсы компании', desc: 'Разбираем изменения, которые действительно происходят в компании, а не абстрактные примеры.' },
  { icon: 'ri-team-line', title: 'Управленческие ситуации', desc: 'Работаем с типовыми ситуациями: сопротивление команды, внедрение стандартов, смена процессов.' },
  { icon: 'ri-user-voice-line', title: 'Ролевые упражнения', desc: 'Руководители тренируются объяснять изменения, отвечать на вопросы и работать с реакцией команды.' },
  { icon: 'ri-shield-flash-line', title: 'Разбор сопротивления', desc: 'Учимся выявлять причину сопротивления и отделять факты от эмоций.' },
  { icon: 'ri-shake-hands-line', title: 'Переговорные ситуации', desc: 'Отрабатываем договорённости с сотрудниками и заинтересованными сторонами при внедрении изменений.' },
  { icon: 'ri-chat-3-line', title: 'Моделирование коммуникаций', desc: 'Тренируем, как объявлять изменения и поддерживать единый информационный контекст.' },
  { icon: 'ri-map-2-line', title: 'Разработка плана внедрения', desc: 'Участники составляют план внедрения изменений для своей реальной ситуации.' },
  { icon: 'ri-feedback-line', title: 'Практика обратной связи', desc: 'Как корректировать действия сотрудников, осваивающих новый способ работы.' },
  { icon: 'ri-close-circle-line', title: 'Разбор ошибок руководителей', desc: 'Анализируем типичные ошибки, которые возвращают компанию к старому способу работы.' },
];

export default function HowPracticeGoes() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Как проходит обучение
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Практика вместо теории: руководители тренируются на ситуациях из своей компании
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {practices.map((p) => (
            <div key={p.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${p.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{p.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto">
          <p className="text-base text-teal-800 leading-relaxed">
            Мы не просто рассказываем о моделях управления изменениями. Руководители тренируются применять инструменты в ситуациях, которые действительно возникают в их компании.
          </p>
        </div>
      </div>
    </section>
  );
}